export const USER_LOGIN_REQUEST = 'USER_LOGIN_REQUEST'
export const USER_LOGIN_SUCCESS = 'USER_LOGIN_SUCCESS'
export const USER_LOGIN_FAIL = 'USER_LOGIN_FAIL'
export const USER_LOGOUT = 'USER_LOGOUT_SUCCESS'



export const COGNITO_LOGIN_REQUEST = 'COGNITO_LOGIN_REQUEST'
export const COGNITO_LOGIN_SUCCESS = 'COGNITO_LOGIN_SUCCESS'
export const COGNITO_LOGIN_FAIL = 'COGNITO_LOGIN_FAIL'


export const GOOGLE_AUTH_REQUEST = 'GOOGLE_AUTH_REQUEST'
export const GOOGLE_AUTH_SUCCESS = 'GOOGLE_AUTH_SUCCESS'
export const GOOGLE_AUTH_FAIL = 'GOOGLE_AUTH_FAIL'


export const USER_REGISTER_REQUEST = 'USER_REGISTER_REQUEST'
export const USER_REGISTER_SUCCESS = 'USER_REGISTER_SUCCESS'
export const USER_REGISTER_FAIL = 'USER_REGISTER_FAIL'


export const PASSWORD_RESET_REQUEST = 'PASSWORD_RESET_REQUEST';
export const PASSWORD_RESET_FAIL = 'PASSWORD_RESET_FAIL';
export const PASSWORD_RESET_SUCCESS = 'PASSWORD_RESET_SUCCESS';


export const PASSWORD_RESET_CONFIRM_FAIL = 'PASSWORD_RESET_CONFIRM_FAIL';
export const PASSWORD_RESET_CONFIRM_SUCCESS = 'PASSWORD_RESET_CONFIRM_SUCCESS';
export const PASSWORD_RESET_CONFIRM_REQUEST = 'PASSWORD_RESET_CONFIRM_REQUEST';


export const USER_FOLLOW_REQUEST = 'USER_FOLLOW_REQUEST'
export const USER_FOLLOW_SUCCESS = 'USER_FOLLOW_SUCCESS'
export const USER_FOLLOW_FAIL = 'USER_FOLLOW_FAIL'


export const PRIVATE_FOLLOW_REQUEST = 'PRIVATE_FOLLOW_REQUEST'
export const PRIVATE_FOLLOW_SUCCESS = 'PRIVATE_FOLLOW_SUCCESS'
export const PRIVATE_FOLLOW_FAIL = 'PRIVATE_FOLLOW_FAIL'

export const NUMBER_REQUEST = 'NUMBER_REQUEST'
export const NUMBER_SUCCESS = 'NUMBER_SUCCESS'
export const NUMBER_FAIL = 'NUMBER_FAIL'
export const NUMBER_RESET = 'NUMBER_RESET'

export const VERIFY_NUMBER_REQUEST = 'VERIFY_NUMBER_REQUEST'
export const VERIFY_NUMBER_SUCCESS = 'VERIFY_NUMBER_SUCCESS'
export const VERIFY_NUMBER_FAIL = 'VERIFY_NUMBER_FAIL'


export const GET_NUMBER_REQUEST = 'GET_NUMBER_REQUEST'
export const GET_NUMBER_SUCCESS = 'GET_NUMBER_SUCCESS'
export const GET_NUMBER_FAIL = 'GET_NUMBER_FAIL'

export const GET_REQUESTS_REQUEST = 'GET_REQUESTS_REQUEST'
export const GET_REQUESTS_SUCCESS = 'GET_REQUESTS_SUCCESS'
export const GET_REQUESTS_FAIL = 'GET_REQUESTS_FAIL'
export const GET_REQUESTS_RESET = 'GET_REQUESTS_RESET'




export const USER_SEND_REQUEST = 'USER_SEND_REQUEST'
export const USER_SEND_SUCCESS = 'USER_SEND_SUCCESS'
export const USER_SEND_FAIL = 'USER_SEND_FAIL'
export const USER_SEND_RESET = 'USER_SEND_RESET'



export const USER_DETAILS_REQUEST = 'USER_DETAILS_REQUEST'
export const USER_DETAILS_SUCCESS = 'USER_DETAILS_SUCCESS'
export const USER_DETAILS_FAIL = 'USER_DETAILS_FAIL'
export const USER_DETAILS_RESET = 'USER_DETAILS_RESET'


export const USER_LIST_REQUEST = 'USER_LIST_REQUEST'
export const USER_LIST_SUCCESS = 'USER_LIST_SUCCESS'
export const USER_LIST_FAIL = 'USER_LIST_FAIL'
export const USER_LIST_RESET = 'USER_LIST_RESET'



export const USER_UPDATE_PROFILE_REQUEST = 'USER_UPDATE_PROFILE_REQUEST'
export const USER_UPDATE_PROFILE_SUCCESS = 'USER_UPDATE_PROFILE_SUCCESS'
export const USER_UPDATE_PROFILE_FAIL = 'USER_UPDATE_PROFILE_FAIL'
export const USER_UPDATE_PROFILE_RESET = 'USER_UPDATE_PROFILE_RESET'



export const USER_DELETE_REQUEST = 'USER_DELETE_REQUEST'
export const USER_DELETE_SUCCESS = 'USER_DELETE_SUCCESS'
export const USER_DELETE_FAIL = 'USER_DELETE_FAIL'


export const ACCOUNT_DELETE_REQUEST = 'ACCOUNT_DELETE_REQUEST'
export const ACCOUNT_DELETE_SUCCESS = 'ACCOUNT_DELETE_SUCCESS'
export const ACCOUNT_DELETE_FAIL = 'ACCOUNT_DELETE_FAIL'







export const USER_UPDATE_REQUEST = 'USER_UPDATE_REQUEST'
export const USER_UPDATE_SUCCESS = 'USER_UPDATE_SUCCESS'
export const USER_UPDATE_FAIL = 'USER_UPDATE_FAIL'
export const USER_UPDATE_RESET = 'USER_UPDATE_RESET'



export const PASSWORD_SEND_REQUEST = 'PASSWORD_SEND_REQUEST'
export const PASSWORD_SEND_SUCCESS = 'PASSWORD_SEND_SUCCESS'
export const PASSWORD_SEND_FAIL = 'PASSWORD_SEND_FAIL'
export const PASSWORD_SEND_RESET = 'PASSWORD_SEND_RESET'

